import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'
import pt from 'vuetify/lib/locale/pt'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#546E7A',
        secondary: '#8bc34a',
        accent: '#607d8b',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#ff9800'
      }
    }
  },
  lang: {
    locales: { pt },
    current: 'pt'
  },
  icons: {
    iconfont: 'md'
  }
})
